import Split from 'libs/split.js';
export default {
  data: {
    modernizr: Modernizr,
    visible: false,
    actionsVisible: false,
    testCompleted: false,
  },
  methods: {
    show (){
      this.$el.className = '';
      this.visible = true;
      if (!this.testCompleted) {
        Split.complete('referral_page_nav_link_copy');
      }
      this.testCompleted = true;
    },
    hide () {
      this.visible = false;
    },
    showActions () {
      this.actionsVisible = true;
    },
    hideActions () {
      this.actionsVisible = false;
    },
    copyLink() {
      const cb = new Clipboard('#js-refer-url');
      cb.on('success', function () {
        new Kadenze.Notice.success({title: 'The link has been copied to your clipboard.'});
      });
    },
    shareFacebook() {

    },
    shareTwitter() {

    }
  },
  mounted() {
    Kadenze.Share.init();
  }
};
